import React from 'react';

import { PrivateRoute as AuthPrivateRoute, PrivateRouteProps } from '@homesusa/auth';
import { Layout } from '../layout.component';

export const PrivateRoute = (props: PrivateRouteProps): JSX.Element => {
  return <AuthPrivateRoute {...props} component={<Layout />} />;
};
